export default __webpack_public_path__ + "static/media/Africa_07.043f6549.png";